"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = exports.Title = exports.Chevron = exports.iconStyles = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
exports.Wrap = app_1.styled.div `
  border-bottom: thin solid ${(theme) => theme.colors.primary};
  transition: all 0.3s;
`;
exports.iconStyles = {
    leftOpen: (0, app_1.css) `
    transform: rotate(-90deg);
  `,
    rightOpen: (0, app_1.css) `
    transform: rotate(-180deg);
  `,
    defaultLeft: (0, app_1.css) `
    justify-self: start;
    margin-right: ${(theme) => theme.spacing.extraSmall};
  `,
    defaultRight: (0, app_1.css) `
    justify-self: end;
  `,
};
exports.Chevron = (0, app_1.styled)(svg_1.SvgChevronDown) `
  width: 1em !important;
  height: 1em !important;
  transition: all 0.15s;
  margin-left: ${(theme) => theme.spacing.small};
  ${(theme) => theme.flexCenter};
  ${(_theme, props) => props.$open && props.$right
    ? exports.iconStyles.rightOpen
    : props.$open && exports.iconStyles.leftOpen};
  ${(_theme, props) => props.$right ? exports.iconStyles.defaultRight : exports.iconStyles.defaultLeft};
`;
exports.Title = app_1.styled.span `
  flex: 1;
`;
exports.Head = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${(theme) => theme.spacing.small};
  cursor: pointer;
`;
